import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 安全检查服务
 */
export class SecurityCheckAMatterController {
    constructor() {
        this.baseurl = 'SecurityCheckAMatterController.assx/';
    }

    /**
     * 获取检查事项的大致信息
     * token:String, matterKeyId:String
     */
    countMatterGoInfo(token, matterKeyId){
        return request.post(this.baseurl + 'countMatterGoInfo', Qs.stringify({ token:token, matterKeyId:matterKeyId }));
    }

    /**
     * 获取专项检查结果图表
     * token:String, title:String, cardKeyId:String, matterKeyId:String
     */
    getSpecialCheckTableByCardId(token, title, cardKeyId, matterKeyId){
        return request.post(this.baseurl + 'getSpecialCheckTableByCardId', Qs.stringify({ token:token, title:title, cardKeyId:cardKeyId, matterKeyId:matterKeyId }));
    }

    /**
     * 获取安全检查详情
     * token:String, keyId:String
     */
    getSecurityCheckMatter(token, keyId){
        return request.post(this.baseurl + 'getSecurityCheckMatter', Qs.stringify({ token:token, keyId:keyId }));
    }

    /**
     * 修改安全检查
     * token:String, matter:SecurityCheckMatter
     */
    modifySecurityCheckMatter(token, matter){
        return request.post(this.baseurl + 'modifySecurityCheckMatter', Qs.stringify({ token:token, matter:typeof matter === 'undefined' || matter === null ? '' : matter.toString() }));
    }

    /**
     * 删除安全检查
     * token:String, keyId:String
     */
    deleteSecurityCheckMatter(token, keyId){
        return request.post(this.baseurl + 'deleteSecurityCheckMatter', Qs.stringify({ token:token, keyId:keyId }));
    }

    /**
     * 二级页面统计，统计完成和截止的安全检查每个行政区域 完成情况和合格率，如果传入keyId,则统计某一次检查的信息
     * token:String, keyId:String
     */
    getSecurityStatisMap(token, keyId){
        return request.post(this.baseurl + 'getSecurityStatisMap', Qs.stringify({ token:token, keyId:keyId }));
    }

    /**
     * 二级页面统计，根据行政区划代码统计信息
     * token:String, eaAreaCode:String
     */
    getSecurityCheckStaData(token, eaAreaCode){
        return request.post(this.baseurl + 'getSecurityCheckStaData', Qs.stringify({ token:token, eaAreaCode:eaAreaCode }));
    }

    /**
     * 获取最近的安全检查统计信息
     * token:String, size:int
     */
    getNextSecurityCheck(token, size){
        return request.post(this.baseurl + 'getNextSecurityCheck', Qs.stringify({ token:token, size:size }));
    }

    /**
     * 获取最近的安全检查统计信息
     * token:String
     */
    getDoingSecurityCheckTask(token){
        return request.post(this.baseurl + 'getDoingSecurityCheckTask', Qs.stringify({ token:token }));
    }

    /**
     * token，获取答题卡列表,仅用与物管企业
     * token:String, status:int, paperType:int, startIndex:int, maxSize:int
     */
    getCardListByRealtyComUser(token, status, paperType, startIndex, maxSize){
        return request.post(this.baseurl + 'getCardListByRealtyComUser', Qs.stringify({ token:token, status:status, paperType:paperType, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 
     * token:String, checkCard:SecurityCheckCard
     */
    addCard(token, checkCard){
        return request.post(this.baseurl + 'addCard', Qs.stringify({ token:token, checkCard:typeof checkCard === 'undefined' || checkCard === null ? '' : checkCard.toString() }));
    }

    /**
     * 模糊查询安全检查标题名称
     * token:String, title:String
     */
    getSecurityNameList(token, title){
        return request.post(this.baseurl + 'getSecurityNameList', Qs.stringify({ token:token, title:title }));
    }

    /**
     * 通过答题卡获取问题列表
     * token:String, cardKeyId:String, startIndex:int, maxSize:int, answer:boolean
     */
    getQuestionByCardId(token, cardKeyId, startIndex, maxSize, answer){
        return request.post(this.baseurl + 'getQuestionByCardId', Qs.stringify({ token:token, cardKeyId:cardKeyId, startIndex:startIndex, maxSize:maxSize, answer:answer }));
    }

    /**
     * 专项检查答案详情
     * token:String, cardKeyId:String, startIndex:int, maxSize:int
     */
    getSpecialCheckAnswerDetail(token, cardKeyId, startIndex, maxSize){
        return request.post(this.baseurl + 'getSpecialCheckAnswerDetail', Qs.stringify({ token:token, cardKeyId:cardKeyId, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 二级页面统计，根据行政区划代码统计信息
     * token:String, keyId:String
     */
    getSecurityStatisMapByCantonCode(token, keyId){
        return request.post(this.baseurl + 'getSecurityStatisMapByCantonCode', Qs.stringify({ token:token, keyId:keyId }));
    }

    /**
     * 获取检查区域明细
     * token:String, matterKeyId:String, cantonCode:String, areaAreaName:String, cardStatus:int, startIndex:int, maxSize:int, child:boolean
     */
    getCardListByMatterKeyId(token, matterKeyId, cantonCode, areaAreaName, cardStatus, startIndex, maxSize, child){
        return request.post(this.baseurl + 'getCardListByMatterKeyId', Qs.stringify({ token:token, matterKeyId:matterKeyId, cantonCode:cantonCode, areaAreaName:areaAreaName, cardStatus:cardStatus, startIndex:startIndex, maxSize:maxSize, child:child }));
    }

    /**
     * 添加安全检查
     * token:String, matter:SecurityCheckMatter
     */
    addSecurityCheckMatter(token, matter){
        return request.post(this.baseurl + 'addSecurityCheckMatter', Qs.stringify({ token:token, matter:typeof matter === 'undefined' || matter === null ? '' : matter.toString() }));
    }

    /**
     * 安全检查列表
     * token:String, para:SecurityCheckMatterQueryPara, paperType:int, startIndex:int, maxSize:int
     */
    querySecurityCheckMatterList(token, para, paperType, startIndex, maxSize){
        return request.post(this.baseurl + 'querySecurityCheckMatterList', Qs.stringify({ token:token, para:typeof para === 'undefined' || para === null ? '' : para.toString(), paperType:paperType, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 专项检查答案统计
     * token:String, cardKeyId:String, startIndex:int, maxSize:int
     */
    getSpecialCheckAnswerStatistics(token, cardKeyId, startIndex, maxSize){
        return request.post(this.baseurl + 'getSpecialCheckAnswerStatistics', Qs.stringify({ token:token, cardKeyId:cardKeyId, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 
     * token:String, keyId:String
     */
    clearMatter(token, keyId){
        return request.post(this.baseurl + 'clearMatter', Qs.stringify({ token:token, keyId:keyId }));
    }

    /**
     * 获取检查区域明细
     * token:String, keyId:String, retChild:boolean
     */
    getCard(token, keyId, retChild){
        return request.post(this.baseurl + 'getCard', Qs.stringify({ token:token, keyId:keyId, retChild:retChild }));
    }

    /**
     * 删除答题卡
     * token:String, keyId:String
     */
    deleteCard(token, keyId){
        return request.post(this.baseurl + 'deleteCard', Qs.stringify({ token:token, keyId:keyId }));
    }

    /**
     * 获取用户所有的答题卡列表
     * token:String, status:int, startIndex:int, maxSize:int, retAnswer:boolean
     */
    getExamineCardListByUser(token, status, startIndex, maxSize, retAnswer){
        return request.post(this.baseurl + 'getExamineCardListByUser', Qs.stringify({ token:token, status:status, startIndex:startIndex, maxSize:maxSize, retAnswer:retAnswer }));
    }
}